// src/firebase.js
import { initializeApp } from "firebase/app";
import { Timestamp, getDocs, deleteDoc, getFirestore, doc, updateDoc, setDoc, getDoc, collection } from "firebase/firestore";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendEmailVerification,
} from "firebase/auth";

import { getAnalytics } from "firebase/analytics";


const firebaseConfig = {
  apiKey: "AIzaSyA_PKvVh-AU8qWQUfP2L-E0NblOmtliQFQ",
  authDomain: "esl-videos.firebaseapp.com",
  projectId: "esl-videos",
  storageBucket: "esl-videos.firebasestorage.app",
  messagingSenderId: "161742981470",
  appId: "1:161742981470:web:cd062b993e7ee9f91ea7cf",
  measurementId: "G-GHJ2MZFVSW"
};




const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

// Google sign-in
export const ensureUserDoc = async (user) => {
  const userDocRef = doc(db, "users", user.uid);
  const userDocSnap = await getDoc(userDocRef);

  let isNewUser = false;

  if (!userDocSnap.exists()) {
    isNewUser = true;
    await setDoc(userDocRef, {
      email: user.email,
      role: "unsubscribed",
      createdAt: Timestamp.fromDate(new Date()),
      emailVerified: false,
      receiveEmails: true,
      displayName: user.displayName || user.email.split('@')[0],
      ttsPlayCount: 0,
      ttsPlayLastUsed: new Date().toISOString().split("T")[0],
      defSentCount: 0,
      defSentLastUsed: new Date().toISOString().split("T")[0],
      trophiesWon: {}, 
      cardsSwiped: 0,
    });
  }

  return isNewUser;
};


// Email/password sign-up
const registerUser = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    // Send verification email
    await sendEmailVerification(user);

    // Add user to Firestore
    await setDoc(doc(db, "users", user.uid), {
      email: user.email,
      role: "unsubscribed",
      createdAt: Timestamp.fromDate(new Date()),
      emailVerified: false,
      receiveEmails: true,
      displayName: user.email.split('@')[0],
      ttsPlayCount: 0,
      ttsPlayLastUsed: new Date().toISOString().split("T")[0],
      defSentCount: 0,
      defSentLastUsed: new Date().toISOString().split("T")[0],
      trophiesWon: {}, 
      cardsSwiped: 0,
    });

    return user;
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
};

const saveList = async (user, userWords) => {
  if (!user || !user.uid || !Array.isArray(userWords)) return;

  const userWordsRef = collection(db, "users", user.uid, "userWords");

  try {
    const existingSnap = await getDocs(userWordsRef);
    const existingIds = existingSnap.docs.map(doc => doc.id);

    const newWordIds = userWords.map(entry =>
      entry.word.replace(/\s+/g, "_").toLowerCase()
    );

    const idsToDelete = existingIds.filter(id => !newWordIds.includes(id));
    
    const deletePromises = idsToDelete.map(id =>
      deleteDoc(doc(userWordsRef, id)).then(() => console.log("deleted:", id))
    );

    const setPromises = userWords.map(entry => {
      const wordId = entry.word.replace(/\s+/g, "_").toLowerCase();
      return setDoc(doc(userWordsRef, wordId), entry).then(() =>
        console.log("saved:", wordId)
      );
    });

    await Promise.all([...deletePromises, ...setPromises]);

  } catch (err) {
    console.error("Error saving user words:", err);
  }
};


// const saveList = async (user, userWords) => {
//   if (!user || !user.uid || !Array.isArray(userWords)) return;

//   const userWordsRef = collection(db, "users", user.uid, "userWords");

//   try {
//     const existingSnap = await getDocs(userWordsRef);
//     const existingIds = existingSnap.docs.map(doc => doc.id);

//     const newWordIds = userWords.map(entry =>
//       entry.word.replace(/\s+/g, "_").toLowerCase()
//     );

//     const idsToDelete = existingIds.filter(id => !newWordIds.includes(id));
//     for (const id of idsToDelete) {
//       await deleteDoc(doc(userWordsRef, id));
//       console.log("deleted:", id);
//     }
//     for (const entry of userWords) {
//       const wordId = entry.word.replace(/\s+/g, "_").toLowerCase();
//       await setDoc(doc(userWordsRef, wordId), entry);
//       console.log("saved:", wordId);
//     }
//   } catch (err) {
//     console.error("Error saving user words:", err);
//   }
// };

export const saveTtsUsage = async (user, count, date) => {
  if (!user || !count || !date) return;

  const userDocRef = doc(db, "users", user.uid);

  await setDoc(userDocRef, {
    ttsPlayCount: count,
    ttsPlayLastUsed: date,
  }, { merge: true });
};


const handleSignOut = async () => {
  await signOut(auth);                    // await saveTtsUsage(user, ttsData.count, ttsData.date);
};


// Email/password login
  async function loginUser(email, password) {

  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;

    const userDocRef = doc(db, "users", user.uid);
    const userDocSnap = await getDoc(userDocRef);

    if (!userDocSnap.exists()) {
      await setDoc(userDocRef, {
        role: "unsubscribed",
        preference: "games",
        emailVerified: false,
        displayName:  user.email.split('@')[0],
        createdAt: Timestamp.fromDate(new Date()),
        ttsPlayCount: 0,
        ttsPlayLastUsed: new Date().toISOString().split("T")[0],
        defSentCount: 0,
        defSentLastUsed: new Date().toISOString().split("T")[0],
        trophiesWon: {},
        cardsSwiped: 0,
      });
      console.log("Created new Firestore user doc after login");
    }

    // Continue with your post-login logic here
    return user; // or whatever you need to return
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
}


const updateUserCounts = async (userId, lookupCount, ttsCount) => {
  try {
    const userRef = doc(db, "users", userId);
    await updateDoc(userRef, {
      defSentCount: lookupCount,
      ttsPlayCount: ttsCount
    });
  } catch (error) {
    console.error("Error updating Firestore:", error);
  }
};


// Logout
const logoutUser = () => {
  return signOut(auth).catch((error) => {
    console.error("Logout Error:", error);
    throw error;
  });
};

export const saveUserPreference = async (choice) => {
  if (!choice) throw new Error("No choice selected");

  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error("No user authenticated");

  await setDoc(doc(db, "users", uid), { preference: choice }, { merge: true });
};


// Export all auth functions
export {
  auth,
  db,
  registerUser,
  updateUserCounts,
  loginUser,
  logoutUser,
  handleSignOut,
  saveList,
  analytics
};